export default "__VITE_ASSET__CLBxN2AT__"